import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/transitional/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { Select } from 'foundations-components/components/Select';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Paginator } from 'foundations-components/transitional/components/Paginator';
import LoadingWrapper from 'marketplace-ui-common/layout/components/LoadingWrapper';
import * as LIST_QUERIES from '../constants/ReviewsListQueries';
import DefaultReviewRenderer from './DefaultReviewRenderer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ReviewsPaginatedList({
  emptyState,
  onUpdateFilters,
  listAlert,
  maxWidth = 750,
  ReviewRenderer = DefaultReviewRenderer,
  reviewRendererProps = {},
  reviews,
  reviewsFetchStatus,
  reviewFilters,
  reviewsTotal,
  reviewsPerPage = LIST_QUERIES.REVIEWS_PER_PAGE,
  searchTerm,
  showPagination = true,
  reviewType,
  onTrackInteraction,
  pageLimitOptions
}) {
  const pageCount = useMemo(() => Math.ceil(reviewsTotal / reviewsPerPage), [reviewsTotal, reviewsPerPage]);
  const renderedList = /*#__PURE__*/_jsxs("div", {
    style: {
      maxWidth
    },
    children: [/*#__PURE__*/_jsxs(TFlex, {
      direction: "column",
      marginBlockEnd: "800",
      children: [listAlert, reviews.map((review, index) => {
        return /*#__PURE__*/_jsx(ReviewRenderer, Object.assign({
          review: review,
          searchTerm: searchTerm,
          borderBottom: pageCount > 1 || reviews.length - 1 > index,
          reviewType: reviewType,
          onTrackInteraction: onTrackInteraction
        }, reviewRendererProps), `${review.get('id')}_${review.get('createdAt')}`);
      })]
    }), showPagination && pageCount > 1 && /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      inlineSize: "100%",
      justifyContent: pageLimitOptions ? 'space-between' : 'center',
      children: [/*#__PURE__*/_jsx(Paginator, {
        "data-test-id": "PAGE-reviews-list-select",
        maxVisiblePageButtons: 5,
        page: reviewFilters.get('page'),
        pageCount: pageCount,
        onPageChange: ({
          target: {
            value
          }
        }) => onUpdateFilters({
          textKey: LIST_QUERIES.PAGE_KEY,
          value
        })
      }), pageLimitOptions && /*#__PURE__*/_jsx(View, {
        children: /*#__PURE__*/_jsx(Select, {
          onSelectedOptionChange: ({
            value
          }) => {
            onUpdateFilters({
              textKey: 'limit',
              value
            });
          },
          options: pageLimitOptions.map(limit => ({
            text: `${limit}`,
            value: limit
          })),
          selectedValues: [reviewFilters.limit]
        })
      })]
    })]
  });
  const renderedEmptyState = emptyState || /*#__PURE__*/_jsx(View, {
    marginBlockStart: "400",
    as: "div",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-ui-reviews.list.emptySearch"
    })
  });
  return reviewsFetchStatus ? /*#__PURE__*/_jsx("div", {
    style: {
      position: 'relative'
    },
    children: /*#__PURE__*/_jsx(LoadingWrapper, {
      requestStatus: reviewsFetchStatus,
      showOverlay: true,
      children: reviewsTotal ? renderedList : renderedEmptyState
    })
  }) : renderedList;
}